<template>
  <tr class="quote-item-row" :class="{adding: !item || isEditing}">
    <td>
      <input v-if="isEditing" type="text" name="sequence" id="sequence" class="form-control" v-model="sequence">
      <span v-else>{{ item && item.sequence }}</span>
    </td>
    <td>
      <v-select v-if="isEditing" v-model="cost_category_id" :options="allCostCategories" class="form-control" :reduce="item => item.id"
                label="name" :searchable="true" :clearable="false" :placeholder="'- Select'"></v-select>
      <span v-else>{{ item && item.cost?item.cost.category.name:'' }}</span>
    </td>
    <td>
      <v-select v-if="isEditing" v-model="cost_matrix_id" :options="filteredCostRecords" class="form-control" :reduce="item => item.id"
                label="description" :searchable="true" :placeholder="'- Cost item'"></v-select>
      <span v-else>{{ item && item.cost?item.cost.description:'' }}</span>
    </td>
    <td>
      <textarea v-if="isEditing" id="details" type="text" class="form-control" rows="2" placeholder="Details" v-model="details"></textarea>
      <span v-else>{{ item && item.details }}</span>
    </td>
    <td>
      <input v-if="isEditing" type="text" name="quantity" id="quantity" class="form-control" v-model="quantity">
      <span v-else>{{ item && item.quantity }}</span>
    </td>
    <td>
      <span v-if="isEditing">{{ quoteMakeup | moneyFormat }}</span>
      <span v-else>{{ item && item.quote_makeup | moneyFormat }}</span>
    </td>
    <td>
      <input v-if="isEditing" type="text" name="cost_rate" id="cost_rate" class="form-control" v-model="cost_rate">
      <span v-else>{{ item && item.cost_rate | moneyFormat }}</span>
    </td>
    <td>
      <span v-if="isEditing">{{ costAmount | moneyFormat }}</span>
      <span v-else>{{ item && item.cost_amount | moneyFormat }}</span>
    </td>
    <td>
      <input v-if="isEditing" type="text" name="quote_rate" id="quote_rate" class="form-control" v-model="quote_rate">
      <span v-else>${{ item?item.quote_rate:null | numberFormat }}</span>
    </td>
    <td>
      <span v-if="isEditing">{{ quoteAmount | moneyFormat }}</span>
      <span v-else>{{ item && item.quote_amount | moneyFormat }}</span>
    </td>
    <td align="right">
      <beat-loader v-if="state == 'saving'"></beat-loader>
      <template v-else>
        <div v-if="isEditing">
          <a href="javascript:;" class="icon-checkmark" v-tooltip="'Save item'"
             @click="saveItem()"></a>&nbsp;
          <a href="javascript:;" class="icon-close" v-tooltip="'Cancel'"
             @click="cancelItem()"></a>
        </div>
        <div v-else>
          <a href="javascript:;" class="icon-pencil" v-tooltip="'Edit item'" @click="editItem"></a>&nbsp;
          <a href="javascript:;" class="icon-trash" v-tooltip="'Remove item'" @click="confDelete"></a>
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
  import { mapState } from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import Service from '@/services/quote'

  export default {
    components: {
      BeatLoader,
    },
    data () {
      return this.initialState();
    },
    props: ['item', 'idx', 'client', 'max_sequence'],
    computed: {
      ...mapState({
        allCostRecords: state => state.option.costs,
        allCostCategories: state => state.option.costCategories,
        quoteItemTypes: state => state.option.quoteItemTypes,
        quote: state => state.quote.quote
      }),
      filteredCostRecords() {
        let self = this, records = [];
        for(let i in self.allCostRecords) {
          if(self.allCostRecords[i].category_id == self.cost_category_id) {
            records.push(self.allCostRecords[i]);
          }
        }
        return records;
      },
      quoteMakeup() {
        if (this.quote_rate && this.cost_rate && this.quantity) {
          let amount = (this.quote_rate - this.cost_rate)*this.quantity;
          if (amount)
            return amount;
        }
        return null;
      },
      costAmount() {
        if (this.cost_rate && this.quantity) {
          let amount = this.cost_rate*this.quantity;
          if (amount)
            return amount;
        }
        return null;
      },
      quoteAmount() {
        if (this.quote_rate && this.quantity) {
          let amount = this.quote_rate*this.quantity;
          if (amount)
            return amount;
        }
        return null;
      }
    },
    watch: {
      cost_category_id ( newVal ) {
        if ( newVal ) {
          let self = this;
          self.cost_matrix_id = '';
          if (self.filteredCostRecords.length == 1) {
            self.cost_matrix_id = self.filteredCostRecords[0].id;
          }
        }
      },
      cost_matrix_id ( newVal ) {
        if ( newVal ) {
          let self = this, cost_item = window.getObjectByKeyValue(self.allCostRecords, 'id', newVal);
          if (cost_item) {
            if (!self.cost_rate)
              self.cost_rate = cost_item.cost;
            if (!self.quote_rate) {
              if (self.client.price_tier)
                self.quote_rate = cost_item['sell_' + self.client.price_tier];
              else
                self.quote_rate = cost_item.sell_tier1;
            }
          }
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      initialState (){
        return {
          state: '',
          cost_category_id: 1,
          cost_matrix_id: '',
          sequence: '',
          quantity: '',
          details: '',
          cost_rate: '',
          quote_rate: '',
          isEditing: false
        }
      },
      loadItem () {
        let self = this;
        if ( !self.item ) {
          return;
        }
        if (self.item.cost)
          self.cost_category_id = self.item.cost.category_id;
        self.cost_matrix_id = self.item.cost_matrix_id;
        self.sequence = self.item.sequence;
        self.quantity = self.item.quantity;
        self.details = self.item.details;
        self.cost_rate = self.item.cost_rate;
        self.quote_rate = self.item.quote_rate;
      },
      init () {
        let self = this;
        Object.assign(this.$data, this.initialState());
        if ( !self.item ) {
          self.isEditing = true;
          if (self.filteredCostRecords.length == 1) {
            self.cost_matrix_id = self.filteredCostRecords[0].id;
          }
          self.sequence = self.max_sequence + 1;
          return;
        }
        self.loadItem();
      },
      editItem () {
        let self = this;
        if ( self.item ) {
          this.loadItem(this.item);
        }
        self.isEditing = true;
      },
      saveItem ( ) {
        let self = this;

        if ( self.state == 'saving' ) {
          return;
        }

        let postData = {};

        if ( !self.item || self.cost_matrix_id != self.item.cost_matrix_id )
          postData.cost_matrix_id = self.cost_matrix_id;

        if ( !self.item || self.sequence != self.item.sequence )
          postData.sequence = self.sequence;

        if ( !self.item || self.quantity != self.item.quantity )
          postData.quantity = self.quantity;

        if ( !self.item || self.details != self.item.details )
          postData.details = self.details;

        if ( !self.item || self.cost_rate != self.item.cost_rate )
          postData.cost_rate = self.cost_rate;

        if ( !self.item || self.quote_rate != self.item.quote_rate )
          postData.quote_rate = self.quote_rate;

        if (!self.isValid())
          return false;

        self.state = 'saving';
        if(self.item) {
          Service.saveItem(self.quote.id, self.item.id, postData, itemData => {
            self.state = '';
            if(typeof itemData.status != 'undefined' && itemData.status == 'FAILED'){
              self.$notify({
                type: 'error',
                text: itemData.error
              });
            }else{
              self.$notify({
                type: 'success',
                text: 'Quote item updated successfully'
              });
              self.$emit('item-saved', itemData, self.idx);
              self.isEditing = false;
              //self.item = itemData;
              //self.init();
            }
          }, () => {
            self.state = '';
          });
        }else{
          Service.createItem(self.quote.id, postData, itemData => {
            self.state = '';
            if(typeof itemData.status != 'undefined' && itemData.status == 'FAILED'){
              self.$notify({
                type: 'error',
                text: itemData.error
              });
            }else {
              self.$notify({
                type: 'success',
                text: 'Quote item created successfully'
              });
              self.$emit('item-saved', itemData, self.idx);
              self.isEditing = false;
              //self.item = itemData;
              //self.init();
            }
          }, () => {
            self.state = '';
          });
        }
      },
      isValid() {
        let self = this, requiredFields = {
          'cost_matrix_id': 'Please select the cost item',
          //'details': 'Please enter the details',
          'quote_rate': 'Please enter the quote rate'
        };
        for(let f in requiredFields) {
          if (!self[f]) {
            self.$notify({
              type: 'error',
              text: requiredFields[f]
            });
            return false;
          }
        }
        return true;
      },
      cancelItem () {
        if (this.item) {
          this.loadItem(this.item);
          this.isEditing = false;
        } else {
          Object.assign(this.$data, this.initialState());
          this.$emit('item-cancelled');
        }
      },
      confDelete () {
        let self = this, item = self.item;
        self.$dialog
          .confirm('Are you sure you want to delete this item?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            Service.deleteItem(item.quote_id, item.id, (data) => {
              dialog.close();
              if(data.status == 'FAILED'){
                self.$notify({
                  type: 'error',
                  text: data.error
                });
              }else {
                self.$emit('item-deleted', self.idx);
              }
            });
          })
          .catch(() => {});
      }
    }
  }
</script>
